import { render, staticRenderFns } from "./dialogCutomRole.vue?vue&type=template&id=0109e996&"
import script from "./dialogCutomRole.vue?vue&type=script&lang=js&"
export * from "./dialogCutomRole.vue?vue&type=script&lang=js&"
import style0 from "./dialogCutomRole.vue?vue&type=style&index=0&id=0109e996&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports